import { connect } from 'react-redux'
import HeaderTop from '../components/HeaderTop'
//import { addTodo } from '../actions'

export default connect(null, {  })(HeaderTop)